/**
 * Vacancy status for a seat term
 */
export var VacancyStatus;
(function (VacancyStatus) {
    VacancyStatus["Immediate"] = "immediate";
    VacancyStatus["Upcoming"] = "upcoming";
})(VacancyStatus || (VacancyStatus = {}));
